export const CHANNEL_KEYS = ["ideasoft", "trendyol", "hepsiburada", "woocommerce", "ticimax", "amazon", "pazarama", "shopify"] as const;
export type ChannelKey = (typeof CHANNEL_KEYS)[number];

export const CHANNEL_LABELS: Record<ChannelKey, string> = {
  ideasoft: "IdeaSoft",
  trendyol: "Trendyol",
  hepsiburada: "Hepsiburada",
  woocommerce: "WooCommerce",
  ticimax: "Ticimax",
  amazon: "Amazon",
  pazarama: "Pazarama",
  shopify: "Shopify",
};

/** Adapter'ın bildirdiği kabiliyet anahtarları. */
export const CAPABILITY_KEYS = [
  "orders.read",
  "orders.update_status",
  "shipments.update_tracking",
  "products.read",
  "inventory.update",
  "pricing.update",
  "returns.read",
  "returns.manage",
  "webhooks",
] as const;
export type CapabilityKey = (typeof CAPABILITY_KEYS)[number];

export type CapabilityVerification = "documented" | "live_verified" | "pending" | "unsupported";

export interface CapabilityEntry {
  supported: boolean;
  verification: CapabilityVerification;
  note?: string;
  requiredScope?: string;
}

export type CapabilityMap = Partial<Record<CapabilityKey, CapabilityEntry>>;

export const CAPABILITY_LABELS: Record<CapabilityKey, string> = {
  "orders.read": "Siparişleri okuma",
  "orders.update_status": "Sipariş durumu güncelleme",
  "shipments.update_tracking": "Kargo takip bilgisi gönderme",
  "products.read": "Ürün ve varyant okuma",
  "inventory.update": "Stok güncelleme",
  "pricing.update": "Fiyat güncelleme",
  "returns.read": "İadeleri okuma",
  "returns.manage": "İade onay/ret",
  webhooks: "Anlık olay bildirimi (webhook)",
};
